'use client';

import styles from './error.module.css';

import { Box, Button, Flex, Heading, Section, Text } from '@radix-ui/themes';
import { useEffect } from 'react';
import { ERROR_MESSAGES } from './lib/constants/error-messages';
import { TRY_AGAIN } from './lib/constants/literals';

const Error = ({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    // Optionally log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <Section size='4'>
      <Flex
        height='100vh'
        direction='column'
        align='center'
        gap='8'
      >
        <Heading
          as='h2'
          align='center'
          size='8'
        >
          {ERROR_MESSAGES.errorPageHeading}
        </Heading>
        <Box width={{ initial: '90%', sm: '70%', lg: '60%' }}>
          <Flex
            direction='column'
            align='center'
            gap='4'
          >
            {ERROR_MESSAGES.errorPageMessages.map((message, i) => (
              <Text
                as='div'
                className={styles.Message}
                key={i}
              >
                {message}
              </Text>
            ))}
          </Flex>
        </Box>
        <Button
          onClick={
            // Attempt to recover by trying to re-render the invoices route
            () => reset()
          }
          aria-label={TRY_AGAIN}
        >
          Попробуйте снова
        </Button>
      </Flex>
    </Section>
  );
};

export default Error;
